import { createElementBlock as t, openBlock as n, createElementVNode as e } from "vue";
import o from "../../../../_virtual/_plugin-vue_export-helper.js";
const r = {}, c = {
  fill: "none",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
function a(i, l) {
  return n(), t("svg", c, [...l[0] || (l[0] = [
    e("rect", {
      fill: "#FFAB00",
      height: "20",
      rx: "4",
      width: "20"
    }, null, -1),
    e("path", {
      d: "M9.125 8.542a1.167 1.167 0 1 1-2.333 0 1.167 1.167 0 0 1 2.333 0Z",
      fill: "#F9F9F9"
    }, null, -1),
    e("path", {
      "clip-rule": "evenodd",
      d: "M4.167 6.208c0-.483.391-.875.875-.875h9.916c.484 0 .875.392.875.875v7.584a.875.875 0 0 1-.875.875H5.042a.875.875 0 0 1-.875-.875V6.208Zm.875-.291a.292.292 0 0 0-.292.291v6.112l1.975-1.536a.583.583 0 0 1 .716 0l1.3 1.01 2.64-2.16a.583.583 0 0 1 .738 0l3.131 2.561V6.208a.292.292 0 0 0-.292-.291H5.042Zm10.208 7.032-3.5-2.864-4.887 3.998h8.095c.161 0 .292-.13.292-.291v-.843Zm-9.308 1.134 2.335-1.91-1.194-.928-2.333 1.814v.733c0 .16.13.291.292.291h.9Z",
      fill: "#F9F9F9",
      "fill-rule": "evenodd"
    }, null, -1)
  ])]);
}
const m = /* @__PURE__ */ o(r, [["render", a]]);
export {
  m as default
};
